<div class="success-container">
  <img class="success-animation" [src]="animationUrl" alt="" (click)="replayAnimation()" />

  <!-- 会社情報・アカウントタイプはログイン後の初期設定で決めるため、ここでは共通の完了メッセージのみ出す -->
  <div class="message-group">
    <div class="title">会員登録完了！</div>
    <div class="subtitle">ようこそ！</div>
  </div>

  <button class="login-button" (click)="onLoginClick()">ログインはこちら</button>
</div>
